// components
import { Typography } from '@centria-ui-atoms/typography'

// prime components
import { Slider as PrSlider } from 'primereact/slider'
import { BlockUI } from 'primereact/blockui'

// styles
import classes from './styles.module.scss'

// types
import type { SliderProps as PrSliderProps } from 'primereact/slider'
import type { FC } from 'react'

export interface SliderProps extends PrSliderProps {
  endLabel?: string
  loading?: boolean
  startLabel?: string
}

export const Slider: FC<SliderProps> = ({
  loading,
  className = '',
  endLabel = 'Fin',
  startLabel = 'Inicio',
  ...props
}) => {
  const formatProgressBarTemplate = (slider: PrSlider | null) => {
    const element = slider?.getElement().querySelector('.p-slider-handle')
    if (element) {
      if (((slider?.props?.value as number) ?? 0) < 100) {
        element.innerHTML = slider?.props.value?.toString() as string
        element.classList.remove('pi', 'pi-check-circle')
      } else {
        element.innerHTML = ''
        element.classList.add('pi', 'pi-check-circle')
      }
    }
  }

  return (
    <BlockUI blocked={loading}>
      <div className={classes.progress}>
        <Typography fontcolor='white'>{startLabel}</Typography>
        <PrSlider
          {...props}
          ref={formatProgressBarTemplate}
          className={classes.progress_bar}
        />
        <Typography fontcolor='white'>
          {(props.value as number) < 100 && endLabel}
        </Typography>
      </div>
    </BlockUI>
  )
}
